import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';

/** Renders a text string with inline LaTeX math ($...$) beautifully via KaTeX. */
export const MathText = ({ children, className = '' }) => (
  <span className={`[&_p]:inline [&_p]:m-0 ${className}`}>
    <ReactMarkdown
      remarkPlugins={[remarkMath]}
      rehypePlugins={[[rehypeKatex, { throwOnError: false, strict: false }]]}
      components={{ p: ({ children }) => <>{children}</> }}
    >
      {String(children || '')}
    </ReactMarkdown>
  </span>
);

export default MathText;
